import { useCallback } from 'react';
import Cookies from 'js-cookie';

function useCookie() {
  const setCookie = useCallback((name, value, options = {}) => {
    Cookies.set(name, value, { expires: 7, path: "/", ...options });
  }, []);

  const getCookie = useCallback((name) => {
    return Cookies.get(name);
  }, []);

  const removeCookie = useCallback((name, options = {}) => {
    Cookies.remove(name, { path: "/", ...options });
  }, []);

  return { setCookie, getCookie, removeCookie };
}

export default useCookie;